import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { SSRGetDoneMark } from '../helper/ssr-get-done-mark';
import { PageSegmentPageLoadMetricsOptions } from '../types';
import { MetricState } from './base-metric';
import { Metric } from './metric';
import { pageLoadMetaMetric } from './page-load-meta-metric';
export class PageSegmentLoadMetric extends Metric {
  constructor(config) {
    super(config);

    _defineProperty(this, "isInitial", true);

    this.config = config;
  }

  startFromPageLoad() {
    var _pageLoadMetaData$sta;

    const pageLoadMetaData = pageLoadMetaMetric.getData();
    this.start({
      startTime: (_pageLoadMetaData$sta = pageLoadMetaData.start) !== null && _pageLoadMetaData$sta !== void 0 ? _pageLoadMetaData$sta : undefined
    });
    this.isInitial = pageLoadMetaData.isInitial;
    this.pageVisibleState = pageLoadMetaData.pageVisibleState;
  }

  mark(mark, timestamp = window.performance.now()) {
    if (mark === PageSegmentLoadMetric.FMP) {
      return;
    }

    super.mark(mark, timestamp);
  }

  markFMP(timestamp) {
    super.mark(PageSegmentLoadMetric.FMP, timestamp);
  }

  getPageSegmentLoadData() {
    return {
      isInitial: this.isInitial
    };
  }

  getData() {
    return { ...super.getData(),
      ...this.getPageSegmentLoadData()
    };
  }

  getDataToMerge() {
    return { ...super.getDataToMerge(),
      ...this.getPageSegmentLoadData()
    };
  }

  merge(mergeData) {
    super.merge(mergeData);
    this.isInitial = mergeData.isInitial;
  }

  stop(params = {}) {
    var _this$config$ssr;

    const pageLoadData = pageLoadMetaMetric.getData();

    if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
      if (!this.marks[PageSegmentLoadMetric.FMP]) {
        const mark = SSRGetDoneMark.getDoneMark();

        if (mark) {
          this.markFMP(mark);
        }
      }
    }

    if (this.config.includePageLoadTimings !== PageSegmentPageLoadMetricsOptions.WAIT_UNTIL_PRESENT || pageLoadData.state === MetricState.FINISHED) {
      return super.stop(params);
    }

    const now = performance.now();

    if (pageLoadData.state === MetricState.STARTED) {
      pageLoadMetaMetric.onStop(() => {
        super.stop({ ...params,
          stopTime: params.stopTime || now
        });
      }, () => {
        this.cancel();
      });
    }

    return true;
  }

}

_defineProperty(PageSegmentLoadMetric, "FMP", 'fmp');